import React from 'react'
import { View, StyleSheet } from 'react-native'
import PropTypes from 'prop-types'

import Txt from '../../../../components/Txt'
import Icon from '../../../../components/Icons'
import Identity from '../../../../utils/Identity'
import { getCardsLocationText } from '../../../../tools/dataParse'
import { TouchableOpacity } from 'react-native-gesture-handler'
import { useTheme } from '../../../../theming/ThemeProvider'
import { usePlatforms } from '../../../../hooks/usePlatforms'

export default function LaneCard (props) {
  const {
    lane,
    onPress
  } = props
  const { theme } = useTheme()
  const { isTablet } = usePlatforms()
  const styles = useStyles(theme, isTablet)

  return (
    <TouchableOpacity
      activeOpacity={0.8} onPress={onPress} style={[
        styles.container,
        Identity.Shadow(theme).Card
      ]}
      testID='dashboardLaneCard'
      accessibilityLabel='dashboardLaneCard'
    >
      <View style={[styles.locationContainer, { marginBottom: 10 }]}>
        <Icon
          name='Location'
          width={13}
          height={13}
          style={styles.icon}
          fill={theme.BUNKER}
        />
        <Txt
          text={getCardsLocationText(lane.origin, true)}
          identity='body3'
          style={styles.originText}
          numberOfLines={1}
          color='CARD_MAIN_TEXT'
        />
      </View>
      <View style={styles.locationContainer}>
        <Icon
          name='Flag'
          width={13}
          height={13}
          style={styles.icon}
          fill={theme.BUNKER}
        />
        <Txt
          text={getCardsLocationText(lane.destination, true)}
          identity='body3'
          color='CARD_NORMAL_TEXT'
          style={styles.destText}
          numberOfLines={1}
        />
      </View>
    </TouchableOpacity>
  )
}

const useStyles = (theme, isTablet) => StyleSheet.create({
  container: {
    margin: 10,
    width: isTablet ? 210 : 180,
    borderRadius: 5,
    backgroundColor: theme.CARD_BACKGROUND,
    padding: 20
  },
  title: {
    fontFamily: 'roboto-bold',
    marginBottom: 7
  },
  locationContainer: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  icon: {
    marginRight: 5
  },
  originText: {
    fontFamily: 'roboto-regular',
    fontSize: 14
  },
  destText: {
    fontFamily: 'roboto-regular',
    fontSize: 13
  }
})

LaneCard.propTypes = {
  lane: PropTypes.object.isRequired,
  onPress: PropTypes.func
}

LaneCard.defaultProps = {
  lane: {},
  onPress: () => {}
}
